import { createSlice } from '@reduxjs/toolkit';
import initialState from './State';

export const jobReducer = createSlice({
  name: 'job',
  initialState,
  reducers: {
    jobAction: (state, action) => {      
      state.job = { ...state.job, ...action.payload };
    },
    setJobAddressData: (state, action) => {
      state.jobAddressData = action.payload;
    },
    setJobOwner: (state, action) => {
      state.jobGetuserData = action.payload;
    },
    // Add new action for field errors
    setFieldErrors: (state, action) => {
      state.fieldErrors = action.payload;
    },
    // Clear field errors
    clearFieldErrors: (state) => {
      state.fieldErrors = {};
    },
    setAssessmentQuestions: (state, action) => {
      if (!state.job) state.job = {};
      state.job.generate_assessment = action.payload;
    },
    updateJobField: (state, action) => {
      const { sectionName, fieldName, value, key, jobGetuserData } = action.payload;

      if (!state.job.dynamic_job_data) {
        state.job.dynamic_job_data = {};
      }
      if (!state.job.dynamic_job_data[sectionName]) {
        state.job.dynamic_job_data[sectionName] = {};
      }

      // Single {id, name} fields
      const singleObjectFields = ["owner", "pipeline", "department", "country", "state", "city"];

      // Multi-object fields (array of {id, name})
      const multiObjectFields = ["members"];

      if (singleObjectFields.includes(fieldName)) {
        state.job.dynamic_job_data[sectionName][fieldName] = { id: value, name: key || '' };
      }
      else if (multiObjectFields.includes(fieldName)) {
        const membersArray = (Array.isArray(value) ? value : [value]).map((val) => {
          const user = jobGetuserData?.list?.find(item => item.account_id === val);
          return { id: user?.account_id || val, name: user?.first_name || '' };
        });

        state.job.dynamic_job_data[sectionName][fieldName] = membersArray;
      }
      else if (fieldName === "description" || fieldName === "job_description" || fieldName === "requirements" || fieldName === "benefits") {
        if (!state.job.dynamic_job_data[sectionName].description) {
          state.job.dynamic_job_data[sectionName].description = {
            job_description: '',
            requirements: '',
            benefits: ''
          };
        }
        
        if (key === 'job_description' || fieldName === 'job_description') {
          state.job.dynamic_job_data[sectionName].description.job_description = value || '';
        } else if (key === 'requirements' || fieldName === 'requirements') {
          state.job.dynamic_job_data[sectionName].description.requirements = value || '';
        } else if (key === 'benefits' || fieldName === 'benefits') {
          state.job.dynamic_job_data[sectionName].description.benefits = value || '';
        }
      }
      else {
        state.job.dynamic_job_data[sectionName][fieldName] = value;
      }

      // Centralized error clearing: remove field error when user enters a value
      // Determine the concrete field key that would be present inside fieldErrors
      const resolvedFieldKey = (() => {
        if (fieldName === 'description' && typeof key === 'string' && key.length > 0) {
          return key; // job_description | requirements | benefits
        }
        return fieldName;
      })();

      const hasNonEmptyValue = (() => {
        if (typeof value === 'string') return value.trim().length > 0;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'number') return !Number.isNaN(value);
        if (typeof value === 'boolean') return true;
        if (value && typeof value === 'object') {
          // for {id,name}
          return Boolean(value.id ?? value.name ?? Object.keys(value).length);
        }
        return Boolean(value);
      })();

      if (hasNonEmptyValue && state.fieldErrors && state.fieldErrors[sectionName]) {
        const normalizedKey = resolvedFieldKey.toLowerCase().replace(/\s+/g, '_');
        state.fieldErrors[sectionName] = state.fieldErrors[sectionName].filter(
          (errField) => errField !== normalizedKey
        );
      }
    }
  },
});

export const { jobAction, setJobAddressData, setJobOwner, setFieldErrors, clearFieldErrors, updateJobField, setAssessmentQuestions } = jobReducer.actions;

export default jobReducer.reducer;
